import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import {
  captureReferralTokenFromLocation,
  extractReferralTokenFromPath,
  extractReferralTokenFromSearch,
  stripReferralParamsFromSearch,
} from '../constants/referralToken';

const AUTH_PATHS_WITH_REF = new Set(['/sign-up', '/sign-in', '/create-account', '/login']);

export function useReferralTokenCapture() {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const fromPath = extractReferralTokenFromPath(pathname);
    const fromQuery = extractReferralTokenFromSearch(search);

    captureReferralTokenFromLocation(pathname, search);

    if (fromPath && pathname.includes('/users/referral/land/')) {
      navigate('/sign-up', { replace: true });
      return;
    }

    if (fromQuery && AUTH_PATHS_WITH_REF.has(pathname)) {
      const cleanedSearch = stripReferralParamsFromSearch(search);
      if (cleanedSearch !== search) {
        navigate({ pathname, search: cleanedSearch }, { replace: true });
      }
    }
  }, [pathname, search, navigate]);
}
